import {
  CoeOfferDetailEntity,
  CoeOfferEntity,
  CoeOfferStrategyDirectionEntity,
} from '@genial/services';
import { ResponsesCoeMarketStatusResponse } from '@genial/services/dist/models';
import { useSetRecoilState } from 'recoil';

import {
  structuredOperationsOffersBySearchTermParams,
  structuredOperationsOffersParams,
  updateStructuredOperationProductSelectedSelector,
  updateStructuredOperationsBillingTypeSelectedSelector,
  updateStructuredOperationsDetailsSelector,
  updateStructuredOperationsMarketStatusSelector,
  updateStructuredOperationsOffersAllSelector,
  updateStructuredOperationsOffersBySearchTermSelector,
  updateStructuredOperationsOptionsFilterSelector,
} from '../selectors';
import {
  StructuredOperationBillingTypeSelected,
  StructuredOperationsOffersBySearchTerm,
  StructuredOperationsOffersParams,
} from '../types';

export const useStructuredOperationsActions = () => {
  const setStructuredOperationsBillingType = useSetRecoilState(
    updateStructuredOperationsBillingTypeSelectedSelector
  );
  const setStructuredOperationsAllOffers = useSetRecoilState(
    updateStructuredOperationsOffersAllSelector
  );
  const setStructuredOperationsBySearchTermOffers = useSetRecoilState(
    updateStructuredOperationsOffersBySearchTermSelector
  );
  const setStructuredOperationsOffersParams = useSetRecoilState(structuredOperationsOffersParams);
  const setStructuredOperationsOffersBySearchTermParams = useSetRecoilState(
    structuredOperationsOffersBySearchTermParams
  );
  const setStructuredOperationsOfferDetails = useSetRecoilState(
    updateStructuredOperationsDetailsSelector
  );
  const setStructuredOperationsOptionsFilter = useSetRecoilState(
    updateStructuredOperationsOptionsFilterSelector
  );
  const setStructuredOperationProductSelected = useSetRecoilState(
    updateStructuredOperationProductSelectedSelector
  );
  const setStructuredOperationMarketStatus = useSetRecoilState(
    updateStructuredOperationsMarketStatusSelector
  );

  const updateStructuredOperationsAllOffers = (value: CoeOfferEntity[]) => {
    setStructuredOperationsAllOffers(value);
  };

  const updateStructuredOperationProductSelected = (value: CoeOfferEntity) => {
    setStructuredOperationProductSelected(value);
  };

  const updateStructuredOperationsBySearchTermOffers = (value: CoeOfferEntity[]) => {
    setStructuredOperationsBySearchTermOffers(value);
  };

  const updateStructuredOperationsBillingType = (value: StructuredOperationBillingTypeSelected) => {
    setStructuredOperationsBillingType(value);
  };

  const updateStructuredOperationsOffersParams = (
    value: Partial<StructuredOperationsOffersParams>
  ) => {
    setStructuredOperationsOffersParams(value);
  };

  const updateStructuredOperationsOffersBySearchTermParams = (
    value: Partial<StructuredOperationsOffersBySearchTerm>
  ) => {
    setStructuredOperationsOffersBySearchTermParams(value);
  };

  const updateStructuredOperationsOfferDetails = (value: CoeOfferDetailEntity) => {
    setStructuredOperationsOfferDetails(value);
  };

  const updateStructuredOperationsOptionsFilter = (value: CoeOfferStrategyDirectionEntity) => {
    setStructuredOperationsOptionsFilter(value);
  };

  const updateStructuredOperationsMarketStatus = (value: ResponsesCoeMarketStatusResponse) => {
    setStructuredOperationMarketStatus(value);
  };
  return {
    updateStructuredOperationsAllOffers,
    updateStructuredOperationsBySearchTermOffers,
    updateStructuredOperationsOffersParams,
    updateStructuredOperationsOffersBySearchTermParams,
    updateStructuredOperationsBillingType,
    updateStructuredOperationsOfferDetails,
    updateStructuredOperationProductSelected,
    updateStructuredOperationsOptionsFilter,
    updateStructuredOperationsMarketStatus,
  };
};
